import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';
import { IChangeWordpData } from 'src/app/shared/interfaces/gmsdata.interface';
import { ILogin, Icontext } from 'src/app/shared/interfaces/login.interface';
import { environment } from '../../../environments/environment';
import { CommonService } from './common.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private baseUrl = "";
  private apiURls;
  private _sessionValue: string = null;
  private _userName: string = null;
  public redirectUrl: string;
  constructor(private http: HttpClient, private cmsSer: CommonService) {
    this.fetchDynaconInfo();
    this.apiURls = environment.urls.api;
    try {
      this.baseUrl = this.cmsSer.getApiBaseUrl();//this.cmsSer.getDynaconData("dynacon_gmsCommonSettings", "apiUrl");
    } catch (exception) {
      throwError(() => "Error while fetching the Dynacon Data" + exception);
    }
    this.baseUrl = this.apiURls.apiBaseUrl;
    if (this.cmsSer.getIsUsnjServer() != -1) {
      this.baseUrl = this.apiURls.apiUsnjBaseUrl;
    }
  }

  public login(reqLoginDetails: ILogin) {
    try {
      this.baseUrl = this.cmsSer.getApiBaseUrl();//this.cmsSer.getDynaconData("dynacon_gmsCommonSettings", "apiUrl");
    } catch (exception) {
      throwError(() => "Error while fetching the Dynacon Data" + exception);
    }
    const context: Icontext = { ip: this.ipAddress, server_name: this.serverName };
    //reqLoginDetails.api_key = this.apiKey;
    reqLoginDetails.context = context;
    if (typeof this.baseUrl == "string") {
      return this.http.post(this.baseUrl + this.apiURls.login, reqLoginDetails).pipe(
        catchError((err) => this.handleError(err, "login"))
      );
    } else {
      alert("Error while login");
      return;
    }
  }

  public changePassword(reqPasswordInfo: IChangeWordpData) {
    // reqPasswordInfo.api_key = this.apiKey;
    let un = sessionStorage.getItem('userName');
    if (un === undefined || un === null) {
      this.userName = this._userName;
      sessionStorage.setItem("userName", this.userName);
    } else {
      this.userName = un;
    }
    reqPasswordInfo.username = this.userName;
    return this.http.post(this.baseUrl + this.apiURls.changewordpUrl, reqPasswordInfo).pipe(
      catchError((err) => this.handleError(err, "changePassword"))
    );
  }
  public doLogOut() {
    try {
      this.baseUrl = this.cmsSer.getApiBaseUrl();//this.cmsSer.getDynaconData("dynacon_gmsCommonSettings", "apiUrl");
    } catch (exception) {
      throwError(() => "Error while fetching the Dynacon Data" + exception);
    }
    return this.http.post(this.baseUrl + this.apiURls.logout, {}).pipe(
      catchError((err) => this.handleError(err, "logout"))
    );
  }
  public set sessionValue(reqvalue: string) {
    this._sessionValue = reqvalue;
    localStorage.setItem("sessionvalue", reqvalue);
  }
  public get sessionValue(): string {
    const sessionValue = localStorage.getItem('sessionvalue');
    if (sessionValue) {
      return sessionValue;
    }
    return this._sessionValue;
  }
  public clearSession() {
    const sessionValue = localStorage.getItem('sessionvalue');
    if (sessionValue) {
      localStorage.removeItem('sessionvalue');
      localStorage.clear();
    }
  }
  public get userName() {
    return this._userName;
  }
  public set userName(reqUserName) {
    let un = sessionStorage.getItem('userName');
    if (un === undefined || un === null) {
      this._userName = reqUserName;
      sessionStorage.setItem("userName", this._userName);
    } else {
      this._userName = un;
    }
    // this._userName = reqUserName;
  }
  get apiKey(): string {
    return "7QqTDdBq5PQ4AdIx";
  }
  get serverName(): string {
    return "new-gms-services";
  }
  get ipAddress() {
    return "10.1.3.5";
  }

  private handleError(error: HttpErrorResponse, reqFrom) {
    console.log('req Eror from :', reqFrom);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('Oops!! Something went wrong. Please check the input values and try again.:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }
  public fetchDynaconInfo() {
    let location = environment.location;
    let dynaconUrl = "";
    if (location == "prodData") {
      dynaconUrl = "https://api.bwin.com/v3/Common.svc/Configuration/bgms:1?x-bwin-accessId=NGE3NTljMGQtYmE1MC00NzMzLWJmMWUtY2RhNDMzNTk5ODMy&";
    } else {
      dynaconUrl = "https://api.bwin.com/v3/Common.svc/Configuration/bgms:1?env=" + location + "&x-bwin-accessId=NGE3NTljMGQtYmE1MC00NzMzLWJmMWUtY2RhNDMzNTk5ODMy&";
    }

    return from(

      fetch((dynaconUrl), {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          console.log('dynaconn configgggg', data);
          let features;
          let keys;
          if (data && data.features) {
            let apiData = data.features;
            let dynConfigObj = {};
            let configDynObj = {};
            let _dynaconKeys = [];

            apiData.forEach(item => {
              if (item.name == "gmsConfigInfo") {
                dynConfigObj[item.name] = item;
                features = item;
                keys = features.keys;
                return;
              }
            });
            //console.log("----->", keys)
            let completeDynaconData = [];
            keys.forEach(item => {
              configDynObj[item.name] = JSON.parse(item.values[0].value);
              let dynaconstoragewrapperkey = 'dynacon_' + item.name;
              //this.notifSer.storeDynaconKey[item.name] = configDynObj[item.name];// dynaconstoragewrapperkey;
              //_dynaconKeys.push(item.name);
              //console.log("keyyssssss", dynaconstoragewrapperkey);
              let keyData = {};
              keyData[dynaconstoragewrapperkey] = configDynObj[item.name]
              completeDynaconData.push(keyData);
              this.setLocalStorageByKey(dynaconstoragewrapperkey, configDynObj[item.name]);
            })
            console.log("final DynaconData---->", completeDynaconData)
          }
        }),
    );
  }
  setLocalStorageByKey(storagekey, response) {
    console.log(response, "responseeeeinit3-->" + storagekey + "<--");
    localStorage.setItem(storagekey, JSON.stringify(response));
  }

}
